module.exports = __webpack_public_path__ + "img/f_b3_rosecrescent.372e22e9.jpg";